import { Typography, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import { SupportPaymentLabel } from './support-payment-label.component';

const useStyles = makeStyles({ name: 'ProviderSupportPaymentDetails' })((theme) => ({
  text: {
    fontSize: 16,
    marginTop: theme.spacing(1),
  },
}));

export type ProviderSupportPaymentDetailsProps = {
  isCashPay?: boolean;
  companyName?: string;
};

export const ProviderSupportPaymentDetails: React.VFC<ProviderSupportPaymentDetailsProps> = ({
  isCashPay,
  companyName,
}) => {
  const { classes } = useStyles();
  const l10n = useL10n();

  const descriptionText = isCashPay
    ? l10n.matching.payment.cashPayDesc
    : l10n.matching.insurance.insuranceQuestions;

  return (
    <Box>
      <SupportPaymentLabel isAcceptInsurance={!isCashPay} text={companyName} />
      <Typography className={classes.text}>{descriptionText}</Typography>
    </Box>
  );
};
